module.exports = __webpack_public_path__ + "media/images/vouch-pattern-5531164c34acddb29a878a06cfe9c41b.jpg";